import { ErrorMessage } from "formik";
import { Container, StyledField } from "./index.styled";
import TextError from "../textError";

export default function Select({
  name,
  options,
  caption,
  placeholder,
  width = "404px",
  height = "56px",
  borderColor,
  titleColor ,
  optionsColor ,
  ...rest
}) {
  return (
    <>
      <Container height={height} width={width}>
        <div>
          <label>{caption}</label>
        </div>
        <StyledField
          as="select"
          id={name}
          name={name}
          height={height}
          width={width}
          borderColor="#BBB"
          titleColor="#27548C"
          optionsColor="#27548C"
          {...rest}
        >
          {options.map((option) => {
            return (
              <option key={option.key} value={option.value} >
                {option.value}
              </option>
            );
          })}
        </StyledField>
        <ErrorMessage component={TextError} name={name} />
      </Container>
    </>
  );
}
